import React, {useState, useEffect, useRef} from 'react';
import {blue, green, purple} from "@material-ui/core/colors";
import {makeStyles} from '@material-ui/core/styles';

var moment = require('moment-jalaali')

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        fontSize: 5,
        display: 'flex',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',
        '&:hover': {
            cursor: 'pointer',
        },


    },

    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    },

    available: {
        width: '100%',
        height: 0,
        position: 'relative',
        paddingBottom: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'iransans',
        fontSize: 10,
        textAlign: 'center',
        margin: 2,
        flex: 1,
        cursor: 'pointer',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        marginBottom: 0,
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.54)',
        '&.hovered': {
            cursor: 'pointer',
            backgroundColor: '#008489',
            opacity: .6
        },
        '&.hovered $availableday': {

            color: '#fff',
        },
        '&.hovered $availableprice': {

            color: '#fff',
        },


    },


    availableselected: {
        width: '100%',
        height: 0,
        position: 'relative',
        paddingBottom: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'iransans',
        fontSize: 10,
        textAlign: 'center',
        margin: 2,
        flex: 1,
        cursor: 'pointer',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        marginBottom: 0,
        backgroundColor: '#008489',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    availableforce: {
        width: '100%',
        height: 0,
        position: 'relative',
        paddingBottom: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'iransans',
        fontSize: 10,
        textAlign: 'center',
        margin: 2,
        flex: 1,
        cursor: 'pointer',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        marginBottom: 0,
        backgroundColor: '#ffffff',
        color: 'rgba(0, 0, 0, 0.54)',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#008489',
        },
        '&:hover $availableday': {

            color: '#fff',
        },
        '&:hover $availableprice': {

            color: '#fff',
        },


    },

    availableday: {
        fontFamily: 'iransans',
        fontSize: 15,
        fontWeight: 'bold',
        color: '#008489',
        position: 'absolute',
        top: 10


    },
    availableprice: {
        fontFamily: 'iransans',
        fontSize: 13,
        marginTop: 5,
        color: '#000000',
        position: 'absolute',
        top: '50%'
    },


    mainreserve: {
        width: '100%',
        height: 0,
        position: 'relative',
        paddingBottom: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'iransans',
        fontSize: 10,
        textAlign: 'center',
        margin: 2,
        flex: 1,
        cursor: 'pointer',
        // pointerEvents: 'none',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        marginBottom: 0,
        backgroundColor: '#fb6060',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    availabledayselected: {
        fontFamily: 'iransans',
        fontSize: 15,
        fontWeight: 'bold',
        color: '#fff',
        position: 'absolute',
        top: 10

    },
    availablepriceselected: {
        fontFamily: 'iransans',
        fontSize: 13,
        color: '#fff',
        marginTop: 5,
        position: 'absolute',
        top: '50%'
    }


}));


function toPersianNum(num, dontTrim) {

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
}


const CalendarItem = (props) => {

    const classes = useStyles();
//     const [disable, setDisable] = useState(props.disable);
//     const [selected, setSelected] = useState(false);
    const [day, setDay] = useState(props.list.Day);
    const [price, setPrice] = useState(props.list.Price);
    const [month, setMonth] = useState(props.month);
    const [year, setYear] = useState(props.year);
    const [rr, setRr] = useState(true);
    const [date, setDate] = useState(year + '/' + month + '/' + day);
//     console.log(props.disable)
//      console.log(disable)
//  {console.log('3')}
//
//     console.log(moment(year + '/' + month + '/' + day, 'jYYYY/jM/jD ').format('YYYY/MM/DD') // 2013-8-25 16:40:00
//     );
//
//     const [persiandate, setPersiandate] = useState(props.persiandate);
    const [georgiandate, setGeorgiandate] = useState(moment(year + '/' + month + '/' + day, 'jYYYY/jM/jD ').format('YYYY/MM/DD'));
    const [type, setType] = useState(props.type);
    // console.log('start');
    const elementRef = useRef(null);


    useEffect(() => {


        setType(props.type);


    }, [props.type]);


    useEffect(() => {
        // setWidth(elementRef.current.clientWidth);
        //  setHeight(elementRef.current.clientWidth);
        // console.log(elementRef.current.clientWidth);
        // setRr(!rr);
        // if(type===1){
        //     alert(1);
        // }

    }, [type]);

    const onClick = () => {
        // alert(type);
        // console.log(props.list);
        if (type === 1) {
            props.handleToUpdate(date, georgiandate, type);

            // setType(2);
        }

        if (type === 2) {
            // setType(3);
            // setType(1);
            props.handleToUpdate(date, georgiandate, type);

            // setType(3);
            // setRr(true);

            // var delayInMilliseconds = 1000; //1 second
            // //
            // setTimeout(function () {
            //    // //  alert(date)
            //    // // setType(4);
            //    // // setRr(!rr);
            //    //  // alert(type);
            //    //   props.handleToUpdate(date, georgiandate, type);
            //    //   alert('2');
            //     setType(4);
            //
            // }, delayInMilliseconds);


            // alert('sdf');
            //3 reserve shode
        }
        if (type === 3) {
            if (props.list.ReserveId === 0) {

                setType(1);

                props.selectreserved(date);


            } else {
                props.showdes(props.list.ReserveId, date);
            }
        }

    };

    const hover = () => {

        props.hover();

    };


    const getComponent = () => {
        // console.log('inin');
        //
        const t = parseInt(type)
        // console.log(t);
        switch (t) {
            case 0:
                return <div ref={elementRef} className={classes.available} style={{
                    pointerEvents: 'none',
                    opacity: '0.4'
                }} onClick={onClick}
                >
                    <div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>
                </div>
            case 1:
                return <div ref={elementRef} className={classes.available} onClick={onClick}
                            onMouseOver={() => props.hover()}
                            onMouseEnter={() => elementRef.current.classList.add('hovered')}
                            onMouseLeave={() => elementRef.current.classList.remove('hovered')}
                >

                    <div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>

                    <div className={classes.availableprice}>{toPersianNum(props.list.Price)}</div>


                </div>

            case 2:
                return <div ref={elementRef} className={classes.availableselected} onClick={onClick}
                            onMouseOver={() => props.hover()}
                            onMouseEnter={() => elementRef.current.classList.add('hovered')}
                            onMouseLeave={() => elementRef.current.classList.remove('hovered')}
                >

                    <div className={classes.availabledayselected}>{toPersianNum(props.list.Day)}</div>

                    <div className={classes.availablepriceselected}>{toPersianNum(props.list.Price)}</div>


                </div>

            case 3:
                return <div ref={elementRef} className={classes.mainreserve} onClick={onClick}
                            onMouseOver={() => props.hover()}
                            onMouseEnter={() => elementRef.current.classList.add('hovered')}
                            onMouseLeave={() => elementRef.current.classList.remove('hovered')}
                >
                    {props.list.ReserveId === 0 ?

                        null
                        :
                        null
                        // <div style={{position: 'absolute',top:'70%', fontFamily: 'iransans', fontWeight: 'bold', color: '#fff'}}>
                        //     ر
                        // </div>
                    }
                    <div className={classes.availabledayselected}>{toPersianNum(props.list.Day)}</div>

                    {props.list.ReserveId === 0 ?

                        <div className={classes.availablepriceselected}>{toPersianNum(props.list.Price)}</div>

                        :
                        <div className={classes.availablepriceselected} style={{fontSize: 8}}>{props.list.Name}</div>
                    }

                </div>

            case 4:

                return <div ref={elementRef} className={classes.availableforce} onClick={onClick}
                            onMouseOver={() => props.hover()}
                            onMouseEnter={() => elementRef.current.classList.add('hovered')}
                            onMouseLeave={() => elementRef.current.classList.remove('hovered')}
                >

                    <div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>

                    <div className={classes.availableprice}>{toPersianNum(props.list.Price)}</div>


                </div>


        }

    };


    return (

        <div>

            {/*{rr ?*/}

            {/*    <div>{getComponent()}</div>*/}

            {/*    :*/}
            {/*    <div>{getComponent()}</div>*/}

            {/*}*/}
            <div>{getComponent()}</div>

            {/*{type ? <div ref={elementRef} className={classes.available} onClick={onClick}*/}
            {/*>*/}

            {/*<div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>*/}

            {/*<div className={classes.availableprice}>{toPersianNum(props.list.Price)}</div>*/}


            {/*</div> : <div ref={elementRef} className={classes.availableselected} onClick={onClick}*/}
            {/*>*/}

            {/*<div className={classes.availabledayselected}>{toPersianNum(props.list.Day)}</div>*/}

            {/*<div className={classes.availablepriceselected}>{toPersianNum(props.list.Price)}</div>*/}


            {/*</div>}*/}


        </div>
    );

};


function gregorian_to_jalali(gy, gm, gd) {
    var g_d_m, jy, jm, jd, gy2, days;
    g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    gy2 = (gm > 2) ? (gy + 1) : gy;
    days = 355666 + (365 * gy) + parseInt((gy2 + 3) / 4) - parseInt((gy2 + 99) / 100) + parseInt((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
    jy = -1595 + (33 * parseInt(days / 12053));
    days %= 12053;
    jy += 4 * parseInt(days / 1461);
    days %= 1461;
    if (days > 365) {
        jy += parseInt((days - 1) / 365);
        days = (days - 1) % 365;
    }
    if (days < 186) {
        jm = 1 + parseInt(days / 31);
        jd = 1 + (days % 31);
    } else {
        jm = 7 + parseInt((days - 186) / 30);
        jd = 1 + ((days - 186) % 30);
    }
    return [jy, jm, jd];
}

function jalali_to_gregorian(jy, jm, jd) {
    var sal_a, gy, gm, gd, days;
    jy += 1595;
    days = -355668 + (365 * jy) + (parseInt(jy / 33) * 8) + parseInt(((jy % 33) + 3) / 4) + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
    gy = 400 * parseInt(days / 146097);
    days %= 146097;
    if (days > 36524) {
        gy += 100 * parseInt(--days / 36524);
        days %= 36524;
        if (days >= 365) days++;
    }
    gy += 4 * parseInt(days / 1461);
    days %= 1461;
    if (days > 365) {
        gy += parseInt((days - 1) / 365);
        days = (days - 1) % 365;
    }
    gd = days + 1;
    sal_a = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
    return [gy, gm, gd];
}


export default CalendarItem;
